<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import AppointmentComparisonCell from "./_modules/appointment-comparison-cell"
  import type { AssignWorkOrderDraft, WorkOrderAssignmentRow } from "../../contract"

  let props: InboxWorkflowCellProps = $props()

  const row = $derived(props.row as unknown as WorkOrderAssignmentRow)
  const draft = $derived(props.draft as AssignWorkOrderDraft)
</script>

<AppointmentComparisonCell {row} {draft} />
